import {  Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs';
import { User } from './models/user.model';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet,RouterModule,CommonModule],
    standalone: true
})
export class AppComponent{
  currentRoute: string = '';
  user$: Observable<User | null>;
  showNavbar: boolean = true;
  constructor(private router: Router, public auth: AuthService){
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
    this.currentRoute = event.urlAfterRedirects;
    this.user$ = this.auth.user$;
  });

  }
  title = 'rental-portal';
   // Navigate to Apply page
   goToApply() {
    this.router.navigate(['/apply']);
  }
  // Navigate to Pay Rent page
  goToPay() {
    this.router.navigate(['/pay']);
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }
  goToDashboard() {
    this.router.navigate(['/tenant']);
  }
  async logout() {
    await this.auth.logout();
    this.router.navigateByUrl('/login');
  }
}
